export enum FieldType {
  EMAIL = "email",
  PHONE = "phone",
  CONTACT = "contact",
  DEFAULT = "default",
};